/*
 * Purpose: Clean app URLs — P6 SSOT (no ?panel= aliases)
 * Last modified: 2026-06-28 | Agent
 * Completeness: 98
 */
export const APP_ROUTES = {
  home: '/',
  dashboard: '/dashboard',
  compose: '/compose',
  flows: '/flows',
  flowTemplates: '/flows/templates',
  flowsTemplates: '/flows/templates',
  missionMap: '/mission/map',
  missionOperateScheduler: '/mission/operate/scheduler',
  missionOperateMonitor: '/mission/operate/monitor',
  missionOperateDebug: '/mission/operate/debug',
  missionInsightsAnalytics: '/mission/insights/analytics',
  missionInsightsLogs: '/mission/insights/logs',
  missionInsightsActivity: '/mission/insights/activity',
  missionInsightsStats: '/mission/insights/stats',
  missionSettingsFlow: '/mission/settings/flow',
  missionSettingsVersions: '/mission/settings/versions',
  missionSettingsShare: '/mission/settings/share',
  connect: '/connect',
  connectSetup: '/connect/setup',
  connectSecrets: '/connect/secrets',
  connectLibrary: '/connect/library',
  connectIntegrations: '/connect/integrations',
  connectMcp: '/connect/mcp',
  authSignIn: '/auth/sign-in',
  authOAuthComplete: '/auth/oauth/complete',
  help: '/help',
  pricing: '/pricing',
  systemStatus: '/status',
  admin: '/admin',
  adminAnalytics: '/admin/analytics',
  adminAiInsights: '/admin/ai-insights',
  adminEngineer: '/admin/engineer',
} as const;

export function withFlowQuery(path: string, flowId?: string | null): string {
  if (!flowId) return path;
  const sep = path.includes('?') ? '&' : '?';
  return `${path}${sep}flow=${encodeURIComponent(flowId)}`;
}

export function missionMapHref(flowId?: string | null): string {
  return withFlowQuery(APP_ROUTES.missionMap, flowId);
}

export function flowsHref(flowId?: string | null): string {
  return withFlowQuery(APP_ROUTES.flows, flowId);
}

/** @deprecated Legacy /builder only — use APP_ROUTES */
export const LEGACY_BUILDER = '/builder';
